<!-- eslint-disable max-len -->
<template>
<svg
    width="32" height="32" viewBox="0 0 32 32"
    fill="none" xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M13.3333 5.46484L16 7.99818" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M25.2017 10.6663L29.0684 9.59961" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M24.0018 16L26.5352 18.6667" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M22.4004 2.93164L21.3337 6.79831" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M19.9511 12.9195C20.0028 12.7978 20.017 12.6633 19.9917 12.5334C19.9665 12.4035 19.903 12.2841 19.8094 12.1906C19.7159 12.097 19.5965 12.0335 19.4666 12.0083C19.3367 11.983 19.2022 11.9972 19.0805 12.0489L4.41378 18.0489C4.28325 18.1024 4.17307 18.196 4.0991 18.3162C4.02514 18.4363 3.99119 18.5768 4.00216 18.7175C4.01313 18.8582 4.06844 18.9917 4.16014 19.0989C4.25184 19.2062 4.37519 19.2815 4.51245 19.3142L10.3111 20.7022C10.5505 20.7594 10.7694 20.8817 10.9435 21.0556C11.1177 21.2295 11.2403 21.4482 11.2978 21.6876L12.6844 27.4875C12.7168 27.6253 12.7921 27.7491 12.8994 27.8413C13.0068 27.9334 13.1407 27.9889 13.2817 27.9999C13.4228 28.0109 13.5636 27.9767 13.684 27.9024C13.8043 27.828 13.8979 27.7173 13.9511 27.5862L19.9511 12.9195Z" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
    />
</svg>
</template>
